import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Student } from './student.model';
import { StudentService } from './student.service';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class StudentPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private studentService: StudentService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.studentService.find(id).subscribe(student => {
                if (student.dateOfBirth) {
                    student.dateOfBirth = {
                        year: student.dateOfBirth.getFullYear(),
                        month: student.dateOfBirth.getMonth() + 1,
                        day: student.dateOfBirth.getDate()
                    };
                }
                this.studentModalRef(component, student);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else {
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.studentModalRef(component, new Student());
            });
        }
    }

    studentModalRef(component: Component, student: Student): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.student = student;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student/student-popup.service.ts